import axios from "axios";
import { sessionData } from "./stores.js";

import { link, replace, location } from "svelte-spa-router";
import { getAuth } from "firebase/auth";

const gapi_url = process.env.BASE_GAMBIT_URL;

function getLanguageIsoCode(countryIsoCode) {
  const countryToLanguageMapping = {
    US: "en", // USA
    IN: "hi", // India
    SE: "sv", // Sweden
    NO: "nb", // Norway
    DK: "da", // Denmark
    FI: "fi", // Finland
    DE: "de", // Germany
    AT: "de", // Austria
    NL: "nl", // Netherlands
    ES: "es", // Spain
    GR: "el", // Greece
    HU: "hu", // Hungary
    PT: "pt", // Portugal
    IE: "en", // Ireland
    CZ: "cs", // Czechia
    SK: "sk", // Slovakia
    PL: "pl", // Poland
    RO: "ro", // Romania
    BG: "bg", // Bulgaria
    UA: "uk", // Ukraine
    EE: "et", // Estonia
    LV: "lv", // Latvia
    LT: "lt", // Lithuania
    BE: "nl", // Belgium
    LU: "lb", // Luxembourg
    TR: "tr", // Turkey
    CA: "en", // Canada (default to English, but note that French is also an official language)
  };
  return countryToLanguageMapping[countryIsoCode] || "Unknown";
}

function isUserRegistered() {
  let session;
  const auth = getAuth();
  const unsubscribe = sessionData.subscribe((s) => (session = s));
  if (session.guser.current_balance != null && auth.currentUser) {
    unsubscribe();
    return true;
  } else {
    unsubscribe();
    return false;
  }
}

async function notify(code, _uid, tc, st) {
  let session;
  const unsub = sessionData.subscribe((s) => (session = s));
  try {
    const response = await axios.post(
      gapi_url + "meta/notify",
      {
        _frcode: code,
        _frusername: session.user.uid,
        _target_uid: _uid,
        _frstake: st,
        _frtc: tc,
      },
      {
        headers: {
          Authorization: `Bearer ${session.user.accessToken}`,
        },
      },
    );
    unsub();
  } catch (e) {
    unsub();
  }
}

async function geo() {
  try {
    const response = await axios.get(gapi_url + "geo");

    if (!response.data.allowed) {
      sessionData.update((s) => ({ ...s, geoFailed: true }));
    }
    sessionData.update((s) => ({ ...s, geoCountry: response.data.country }));
    return response.data.allowed;
  } catch (e) {
    console.error("geolookup failed", e);
  }
}

async function getLegal() {
  let session;
  const unsub = sessionData.subscribe((s) => (session = s));
  try {
    await geo();
    const response = await axios.get(gapi_url + "meta/legal", {
      params: {
        lang:
          session.geoCountry === "US"
            ? "en_us"
            : getLanguageIsoCode(session.geoCountry),
      },
    });
    unsub();
    return response.data;
  } catch (e) {
    const response = await axios.get(gapi_url + "meta/legal", {
      params: {
        lang: "en",
      },
    });
    unsub();
    return response.data;
  }
}

async function isUserRegistered_() {
  const auth = getAuth();
  let tok = await auth.currentUser.getIdToken();

  try {
    const response = await axios.get(gapi_url + "meta/gametypes", {
      headers: {
        Authorization: `Bearer ${tok}`,
      },
    });

    if (response) {
      unsubscribe();
      locUnsubscribe();
      return true;
    }
  } catch (e) {
    return false;
    unsubscribe();
    locUnsubscribe();
  }
}

async function updateBalance() {
  setTimeout(async () => {
    let session;

    const unsub = sessionData.subscribe((s) => (session = s));

    let tok = await session.user.getIdToken();
    // let tok = auth.currentUser.accessToken

    try {
      const response = await axios.get(gapi_url + "meta/gametypes", {
        headers: {
          Authorization: `Bearer ${tok}`,
        },
      });

      const creditsResponse = await axios.get(
        gapi_url + "puzzle/puzzle_credits",
        {
          headers: {
            Authorization: `Bearer ${tok}`,
          },
        },
      );

      sessionData.update((s) => {
        s.guser = response.data;
        s.puzzleCredits = creditsResponse.data.credits;
        return s;
      });
    } catch (e) {
      console.error("registration error", e, tok);
    }
  }, 1000);
}

async function getUserData() {
  let session;
  let loc;

  const unsub = sessionData.subscribe((s) => (session = s));
  const unsubl = location.subscribe((l) => (loc = l));

  let tok = await session.user.getIdToken();

  const puzzleRatingResponse = await axios.get(
    gapi_url + "puzzle/puzzle_rating",
    {
      headers: {
        Authorization: `Bearer ${tok}`,
      },
    },
  );

  try {
    const response = await axios.get(gapi_url + "meta/gametypes", {
      headers: {
        Authorization: `Bearer ${tok}`,
      },
    });

    sessionData.update((s) => {
      s.guser = response.data;
      s.puzzleRating = puzzleRatingResponse.data.rating;
      return s;
    });
    if (!loc.startsWith("/sumsub")) {
      replace("/Play");
    }
    unsub();
    unsubl();
  } catch (e) {
    if (loc == "/" || loc == "/Login") {
      sessionData.update((s) => {
        s.signin_flow = "details";
        unsub();
        unsubl();
        return s;
      });
    } else {
      unsub();
      unsubl();
    }
  }
}

async function getGameHistory() {
  let session;
  sessionData.subscribe((s) => (session = s));
  let tok = await session.user.getIdToken();
  const response = await axios.get(gapi_url + "users/gamehistory", {
    headers: {
      Authorization: `Bearer ${tok}`,
    },
  });
  return response.data;
}

async function getCountries() {
  let session;
  sessionData.subscribe((s) => (session = s));
  let tok = await session.user.getIdToken();
  const response = await axios.get(gapi_url + "meta/available_countries", {
    headers: {
      Authorization: `Bearer ${tok}`,
    },
  });
  return response.data;
}

async function getSupportInfo() {
  let session;
  sessionData.subscribe((s) => (session = s));
  let tok = await session.user.getIdToken();
  const response = await axios.get(gapi_url + "meta/support", {
    headers: {
      Authorization: `Bearer ${tok}`,
    },
  });
  return response.data;
}

export {
  getUserData,
  getCountries,
  isUserRegistered,
  updateBalance,
  geo,
  getLegal,
  notify,
};
